import { styled, keyframes } from '@clickcease/cc-client-components-lib'
import * as Toast from '@radix-ui/react-toast'

const hide = keyframes({
  '0%': { opacity: 1 },
  '100%': { opacity: 0 },
})

const slideIn = keyframes({
  from: { transform: `translateX(calc(100% + 56px))` },
  to: { transform: 'translateX(0)' },
})

const swipeOut = keyframes({
  from: { transform: 'translateX(var(--radix-toast-swipe-end-x))' },
  to: { transform: `translateX(calc(100% + 56px))` },
})

export const ToasterProvider = styled(Toast.Provider, {})

export const ToasterViewport = styled(Toast.Viewport, {
  position: 'fixed',
  top: '$28',
  right: '$28',
  display: 'flex',
  flexDirection: 'column',
  gap: '$8',
  zIndex: 314159265359,
  listStyle: 'none',
  outline: 'none',
})

export const ToasterRoot = styled(Toast.Root, {
  width: '450px',
  borderRadius: '8px',
  boxShadow: ' 0px 0px 30px rgba(102, 102, 102, 0.05)',
  fontWeight: '$l',
  fontSize: '$md',
  display: 'flex',
  alignItems: 'center',
  border: '1px solid',
  padding: '10px',

  variants: {
    type: {
      success: {
        color: '$success',
        borderColor: '$successLight',
        background: '$successLighter',
        span: {
          color: '$success',
        },
      },
      failure: {
        color: '$error',
        borderColor: '$errorLight',
        background: '$errorLighter',
        span: {
          color: '$error',
        },
      },
      info: {
        color: '$info',
        borderColor: '$infoLight',
        background: '$infoLighter',
        span: {
          color: '$info',
        },
      },
      warning: {
        color: '$warning',
        borderColor: '$warningLight',
        background: '$warningLighter',
        span: {
          color: '$warning',
        },
      },
    },
  },

  '&[data-state="open"]': {
    animation: `${slideIn()} 150ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  '&[data-state="closed"]': {
    animation: `${hide()} 100ms ease-in`,
  },
  '&[data-swipe="move"]': {
    transform: 'translateX(var(--radix-toast-swipe-move-x))',
  },
  '&[data-swipe="cancel"]': {
    transform: 'translateX(0)',
    transition: 'transform 200ms ease-out',
  },
  '&[data-swipe="end"]': {
    animation: `${swipeOut()} 100ms ease-out`,
  },
})

export const ToastMessage = styled('span', {
  width: '400px',
  paddingInline: '$4',
  overflowWrap: 'normal',
})

export const CloseToaster = styled(Toast.Close, {
  all: 'unset',
  cursor: 'pointer',
  padding: '$2',
})

export const ToasterIcon = styled('div', {
  marginInlineEnd: '8px',

  ['img']: {
    display: 'block',
  },
})
